<cc-dashboard-page-container [isLoading]="isLoading$ | async">
  <ng-container title>
    <span>{{
      'sidebar.settings.subitems.FRONTOFFICE_INT_ROLES' | transloco
    }}</span>
  </ng-container>

  <cc-table-preview page-content>
    <cc-table-container>
      <div table-buttons>
        <cc-add-action-button
          [routerLink]="[navigateUrl, 'preview', 'new']"
        ></cc-add-action-button>
      </div>

      <bo-mat-table
        #table
        matSort
        [data]="paging$ | async"
        [showPaginator]="false"
        (matSortChange)="onSort($event)"
        (pageChange)="setPage($event)"
      >
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <span>{{ 'role.fields.NAME' | transloco }}</span>
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.name }}
          </td>
        </ng-container>

        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <span>{{ 'role.fields.DESCRIPTION' | transloco }}</span>
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.description }}
          </td>
        </ng-container>
      </bo-mat-table>
    </cc-table-container>
  </cc-table-preview>
</cc-dashboard-page-container>
